import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import RouterSideNav from 'ui-addon-react-router-dom/RouterSideNav';
import RouterSideNavItem from 'ui-addon-react-router-dom/RouterSideNavItem';
import { prefetchPage } from '../../../routes/loadablePages';
import { usePreserveQueryParams } from '../../../v2/hooks/utilities/usePreserveQueryParams';
import CurrencyPicker from '../../common/CurrencyPicker';
import DesktopSideNav from './DesktopSideNav';
import MobileSideNav from './MobileSideNav';
import { useSideNavItems } from './useSideNavItems';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SideNav = ({
  selectedNavItem
}) => {
  const isMobile = useIsMobile();
  const createToWithQueryParams = usePreserveQueryParams();
  const {
    visibleSections,
    visibleItemsBySection
  } = useSideNavItems();
  const navItems = visibleSections.map((navSection, index) => /*#__PURE__*/_jsx(RouterSideNav, {
    divider: index !== 0,
    headingText: I18n.text(`pricingPage.sidenav.sections.${navSection}`),
    children: visibleItemsBySection[navSection].map(navItem => /*#__PURE__*/_jsx(RouterSideNavItem, {
      "data-test-id": `side-nav-${navItem}`,
      "data-is-active": selectedNavItem === navItem,
      "data-selenium-class": "side-nav",
      active: selectedNavItem === navItem,
      title: /*#__PURE__*/_jsx(Text, {
        textWrap: "nowrap",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `pricingPage.pages.products.tabs.${navItem}.tabTitle`
        })
      }),
      to: createToWithQueryParams(`/${navItem}`),
      padding: "400",
      marginInlineStart: "300",
      onMouseEnter: () => prefetchPage(navItem)
    }, navItem))
  }, navSection));
  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileSideNav, {
      selectedNavItem: selectedNavItem,
      children: navItems
    });
  }
  return /*#__PURE__*/_jsxs(DesktopSideNav, {
    children: [navItems, /*#__PURE__*/_jsx(CurrencyPicker, {})]
  });
};
export default SideNav;